import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Text } from 'components/Typography'

export const SWrapper = styled(Button)`
  display: flex;
  min-height: 4.5rem;

  align-items: center;
  padding: 0.4rem 1rem;
  background-color: transparent;

  &:not(:last-of-type) {
    margin-bottom: 0.75rem;
  }

  & > span {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 1rem;
  }
`

export const SImageWrapper = styled.div`
  min-width: 3rem;
  max-width: 3rem;
  height: 3rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
  }
`

export const SImage = styled.img`
  width: 100%;
  height: 100%;
`

export const STextWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  text-align: left;
`

export const STitle = styled(Text)`
  color: var(--c-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SSubtitle = styled(Text)`
  font-weight: normal;
`
